/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import firebase from 'firebase/compat/app';
import { AngularFireDatabase, SnapshotAction } from '@angular/fire/compat/database';
import { AbstractTicketIndexQuery } from './abstract-ticket-index-query';
import { Observable } from 'rxjs';
import { TicketIndexLogger } from '../ticket-index-logger.service';
import { ITicketIndexData } from '../ticket-index-data';

/**
 */
export class SimpleIndexQuery extends AbstractTicketIndexQuery {
	// This can be changed after a SimpleIndexQuery is constructed and first given to a consuming TicketIndexQuery;
	// the modified query can then be re-sent to the TicketIndexQuery:
	public queryFunctionToApplyToRef: (ref: firebase.database.Reference) => firebase.database.Query;

	constructor(
		db: AngularFireDatabase,
		protected logger: TicketIndexLogger,
		queryFunctionToApplyToRef: (ref: firebase.database.Reference) => firebase.database.Query
	) {
		super(db, logger);
		this.queryFunctionToApplyToRef = queryFunctionToApplyToRef;
	}

	public getIndexSnapshot$(projectId: string, planId: string): Observable<SnapshotAction<ITicketIndexData>> {
		return super.simpleQuerySnapshot$(projectId, planId, this.queryFunctionToApplyToRef);
	}
}
